import { DraggableLocation } from "@hello-pangea/dnd";
import { KanbanBoardColumnT } from "../../../types/orderStatusTypes";

export const reorderBoardColumn = (
  list: KanbanBoardColumnT,
  startIndex: number,
  endIndex: number
) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const moveBetweenBoardColumns = (
  source: KanbanBoardColumnT,
  destination: KanbanBoardColumnT,
  droppableSource: DraggableLocation,
  droppableDestination: DraggableLocation
) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {} as {
    [key: string]: KanbanBoardColumnT;
    ind: KanbanBoardColumnT;
  };

  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};